var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7327 3.32002L12.9593 1.20002C13.066 0.993357 12.986 0.740023 12.786 0.633357C12.5927 0.533357 12.3527 0.593357 12.2327 0.780024L10.9793 2.94002C9.07268 2.13336 6.92602 2.13336 5.01935 2.94002L3.76602 0.780024C3.63935 0.58669 3.37935 0.52669 3.18602 0.64669C2.99935 0.76669 2.93935 1.00669 3.03935 1.20002L4.26602 3.32002C2.19935 4.50002 0.852682 6.62669 0.666016 9.00002H15.3327C15.146 6.62669 13.7993 4.50002 11.7327 3.32002ZM4.66602 7.16669C4.20602 7.16669 3.83268 6.79336 3.83268 6.33336C3.83268 5.87336 4.20602 5.50002 4.66602 5.50002C5.12602 5.50002 5.49935 5.87336 5.49935 6.33336C5.49935 6.79336 5.12602 7.16669 4.66602 7.16669ZM11.3327 7.16669C10.8727 7.16669 10.4993 6.79336 10.4993 6.33336C10.4993 5.87336 10.8727 5.50002 11.3327 5.50002C11.7927 5.50002 12.166 5.87336 12.166 6.33336C12.166 6.79336 11.7927 7.16669 11.3327 7.16669Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android_icon.5cba82b8d3b8c88cbc8878ff9c2e622e.svg";
export { ForwardRef as ReactComponent };